import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { ExamsDetailsTypes } from '../../interfaces/exams.interface';
import ExaminiResult from './ExaminiResult';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type ShowResultDialogProps={
    resultDetails?: ExamsDetailsTypes|null;
    handleClose:()=>any;
}
const ShowResultDialog:React.FC<ShowResultDialogProps> = ({handleClose,resultDetails}):JSX.Element=> {

  return (
    <React.Fragment>
      
      <Dialog
        fullScreen
        open={resultDetails  ? Boolean(resultDetails?.exam_group) : false}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
          {/* <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div"  className=''>
                {resultDetails?.title}
            </Typography> */}
            
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            
          </Toolbar>
        </AppBar>
        {
            resultDetails  && resultDetails?.exam_group ? (
                <div className="mt-3">
                <ExaminiResult exam_group_id={resultDetails?.exam_group}/>

            </div>

            ):(
                <></>
            )
            
        }
        
        
      </Dialog>
    </React.Fragment>
  );
}

export default ShowResultDialog